import React, { useState, useEffect } from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import styled from 'styled-components';

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from '@mui/icons-material/Save';

import constants from "../../const";
import { helper } from "../common/helper";

const PositionCardContainer = styled.div`
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 16px rgba(15, 118, 110, 0.2);
        transform: translateY(-2px);
    }
`;

const PositionImageWrapper = styled.div`
    position: relative;
    height: 100px;
    width: 100%;
    overflow: hidden;
    background: #f0f0f0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
            filter: brightness(1.1) saturate(1.1);
        }
    }
`;

const PositionNameOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 8px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 40%, rgba(0, 0, 0, 0));
    color: white;
    font-weight: 600;
    font-size: 12px;
    max-height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 10;
`;

const ActionButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    color: white;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    opacity: 0.75;

    &:hover {
        opacity: 1;
        transform: scale(1.1);
    }
`;

const ActionOverlay = styled.div`
    position: absolute;
    right: 6px;
    top: 6px;
    display: flex;
    gap: 2px;
    z-index: 20;
`;

const EditPositionButton = styled.button`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
`;

const PositionInfoSection = styled.div`
    padding: 10px 12px;
    background: white;
`;

const TimeDisplay = styled.div`
    color: #666;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

const TimeInput = styled.input`
    background: rgba(15, 118, 110, 0.1);
    border: 1px solid #0f766e;
    border-radius: 4px;
    padding: 4px 6px;
    font-size: 11px;
    color: #333;
    width: 45px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        background: white;
        border-color: #06b6d4;
        box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.2);
    }
`;

function PositionCard(props) {
    var token = "";
	if (localStorage.getItem("token") != null) {
		token = localStorage.getItem("token");
	}
	var tokenUrl = `?token=${token.slice(7)}`;
    var imageURL = `${constants.CONTENT_DOMAIN}download/sus-media/positions/`;

    const [editMode, setEditMode] = useState(false);
    const [scenePosition, setScenePosition] = useState({
        id: 1,
        scene: 1,
        position: 1,
        name: "PositionName",
        startTime: 300,
        endTime: 1000
    });

    const jump = () =>{
      props.jumpVideo(scenePosition.startTime)
      console.log("Jump")
    }

    useEffect(()=>{
        setScenePosition(props.position)
    },[props.position])

    const changeMode = () =>{
        if(editMode){
            setEditMode(false)
        }
        else{
            setEditMode(true)
        }
    }

    const saveChange = () =>{
        setEditMode(false)
        props.update(scenePosition)
    }

    const deletePosition = () =>{
        props.remove(scenePosition)
    }


  return (
    <PositionCardContainer>
      <PositionImageWrapper>
        <img 
          onClick={jump} 
          src={`${imageURL}${scenePosition.position}.png${tokenUrl}`} 
          alt={scenePosition.name}
        />
        <PositionNameOverlay>
          {!editMode ? (
            scenePosition.name
          ) : (
            <EditPositionButton onClick={() => props.onChangePosition(scenePosition.id)}>
              ⚙️ {scenePosition.name}
            </EditPositionButton>
          )}
        </PositionNameOverlay>
        <ActionOverlay>
          {props.perms.some(e => e.role.id === 2) ? (
            <>
              <ActionButton onClick={changeMode} title={editMode ? "Cancel" : "Edit"}>
                <EditIcon fontSize="small" />
              </ActionButton>
              {editMode ? (
                <ActionButton onClick={saveChange} title="Save">
                  <SaveIcon fontSize="small" />
                </ActionButton>
              ) : null}
              {editMode ? (
                <ActionButton onClick={deletePosition} title="Delete">
                  <DeleteIcon fontSize="small" />
                </ActionButton>
              ) : null}
            </>
          ) : null}
        </ActionOverlay>
      </PositionImageWrapper>

      {props.perms.some(e => e.role.id === 2) ? (
        <PositionInfoSection>
          <TimeDisplay>
            {!editMode ? (
              `${scenePosition.startTime} - ${scenePosition.endTime}`
            ) : (
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center', fontSize: '11px' }}>
                <TimeInput 
                  key={`start-${scenePosition.id}`}
                  size="3" 
                  value={scenePosition.startTime} 
                  onChange={(e) => setScenePosition({...scenePosition, startTime: e.target.value})}
                  placeholder="Start"
                />
                <span style={{ fontSize: '11px' }}>to</span>
                <TimeInput 
                  key={`end-${scenePosition.id}`}
                  size="3" 
                  value={scenePosition.endTime} 
                  onChange={(e) => setScenePosition({...scenePosition, endTime: e.target.value})}
                  placeholder="End"
                />
              </div>
            )}
          </TimeDisplay>
        </PositionInfoSection>
      ) : null}
    </PositionCardContainer>
  );


}

const mapStateToProps = (state) => {
  return {
      perms: state.users.permissions.perms
  }
}

const mapDispatchToProps = (dispatch) => {

}

export default connect(mapStateToProps, mapDispatchToProps)(PositionCard)